<template>
  <v-layout row justify-center>
    <v-dialog :value="value" scrollable @input="$emit('input')" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline"><v-icon>fa-camera</v-icon> Foto animal</span>
        </v-card-title>
        <v-card-text>
          <div class="text-xs-center"
            v-if="!animal"
          >
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>

          <v-container grid-list-lg fluid class="photo-animal-container">

            <v-layout row wrap v-if="animal">
              <v-flex xs12 md6>
                <v-img 
                  :src="animal.image"
                  ></v-img>
              </v-flex>
              <v-flex xs12 md6>
                <image-grid-info
                  :animal="animal"
                  :auxs="auxs"
                ></image-grid-info>
              </v-flex>
            </v-layout>

          </v-container>
          
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialog">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import ImageGridInfo from './ImageGridInfo'
export default {
  components: {
    'image-grid-info' : ImageGridInfo,
  },
  props : ['value', 'animal', 'auxs'],
  data: () => ({
    
  }),
  mounted () {
    
  },
  methods : {
    closeDialog() {
      this.$emit('input');
    }
  }
}
</script>

<style scoped lang="css">
.photo-animal-container {
  padding: 0px;
}
</style>
